// import { useState, useMemo, useEffect, Fragment } from "react";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import Loader from "../components/Loader";
// import {
//   useReactTable,
//   getCoreRowModel,
//   flexRender,
// } from "@tanstack/react-table";
// import Pagination from "@mui/material/Pagination";
// import {
//   FiCalendar,
//   FiClock,
//   FiZap,
//   FiTrendingUp,
//   FiCheckCircle,
//   FiXCircle,
//   FiChevronDown,
//   FiChevronUp,
//   FiChevronLeft,
//   FiChevronRight,
//   FiServer,
//   FiActivity,
//   FiRefreshCw,
//   FiPower,
//   FiSun,
//   FiMoon,
//   FiFilter,
//   FiAlertCircle,
//   FiLoader,
//   FiX,
// } from "react-icons/fi";

// function getObjectSizeSafe(obj) {
//   try {
//     const json = JSON.stringify(obj);
//     return new TextEncoder().encode(json).length;
//   } catch (err) {
//     return null; // cyclic object
//   }
// }
// export default function DashboardDetailed() {
//   const token = useSelector((state) => state.user.token);

//   const [viewMode, setViewMode] = useState("monthly"); // "weekly" | "monthly"

//   // Date range state
//   const [startDate, setStartDate] = useState(() => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   });
//   const [endDate, setEndDate] = useState(() => {
//     const today = new Date();
//     const maxDate = new Date(today);
//     maxDate.setDate(today.getDate() + 7);
//     return maxDate.toISOString().split("T")[0];
//   });

//   // Data and UI state
//   const [data, setData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [limit] = useState(100);
//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 5,
//     total: 0,
//     totalPages: 1,
//   });

//   const [expanded, setExpanded] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [statsLoading, setStatsLoading] = useState(false);
//   const [stats, setStats] = useState({
//     totalSchedules: 0,
//     activeSchedules: 0,
//     totalDevices: 0,
//     upcomingRuns: 0,
//   });
//   const [dateError, setDateError] = useState("");
//   const [showDatePicker, setShowDatePicker] = useState(false);
//   const [tempStartDate, setTempStartDate] = useState(startDate);
//   const [tempEndDate, setTempEndDate] = useState(endDate);
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   function ExpandedSchedule({ schedule }) {
//     const [runFilter, setRunFilter] = useState("upcoming");

//     const runs = schedule.runs || [];
//     const MAX_RANGE_DAYS = 730; // 2 years

//     const filteredRuns = runs.filter(
//       (r) => runFilter === "all" || r.date_status === runFilter,
//     );

//     const counts = {
//       passed: runs.filter((r) => r.date_status === "passed").length,
//       upcoming: runs.filter((r) => r.date_status === "upcoming").length,
//     };

//     return (
//       <div className="space-y-6 animate-fade-in">
//         {/* Summary Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//           <InfoCard
//             icon={<FiClock className="text-blue-600" size={20} />}
//              label="Calender Type"
//           value={
//             schedule.when?.calenderType
//               ? schedule.when.calenderType.charAt(0).toUpperCase() +
//               schedule.when.calenderType.slice(1)
//               : "N/A"
//           }
//             bgColor="bg-blue-50"
//             borderColor="border-blue-200"
//           />
//           <InfoCard
//             icon={<FiCalendar className="text-purple-600" size={20} />}
//             label="Round to Closest"
//             value={`${schedule?.roundtoclosest ?? 0} Min`}
//             bgColor="bg-purple-50"
//             borderColor="border-purple-200"
//           />
//           {/* <InfoCard
//           icon={<FiZap className="text-yellow-600" size={20} />}
//           label="Timezone"
//           value={schedule.when?.timezone || "N/A"}
//           bgColor="bg-yellow-50"
//           borderColor="border-yellow-200"
//         /> */}
//           <InfoCard
//             icon={<FiRefreshCw className="text-indigo-600" size={20} />}
//             label="Calender Type"
//             value={
//               schedule.when?.scheduleType
//                 ? schedule.when.calenderType.charAt(0).toUpperCase() +
//                   schedule.when.calenderType.slice(1)
//                 : "N/A"
//             }
//             bgColor="bg-indigo-50"
//             borderColor="border-indigo-200"
//           />
//           {typeof schedule.smartRestore === "boolean" && (
//             <InfoCard
//               icon={<FiRefreshCw className="text-emerald-600" size={20} />}
//               label="Smart Restore"
//               value={schedule.smartRestore ? "On" : "Off"}
//               bgColor="bg-emerald-50"
//               borderColor="border-emerald-200"
//             />
//           )}
//         </div>

//         {/* Devices Section */}
//         {schedule.actions && schedule.actions.length > 0 && (
//           <div className="bg-white rounded-xl border border-gray-200 p-6">
//             <div className="flex items-center gap-3 mb-5">
//               <div className="p-2 bg-indigo-100 rounded-lg">
//                 <FiServer className="text-indigo-600" size={20} />
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Devices ({schedule.actions.length})
//               </h3>
//             </div>
//             <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
//               {schedule.actions.map((d) => (
//                 <DeviceCard key={d._id || Math.random()} device={d} />
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Run History Section */}
//         {runs.length > 0 && (
//           <div className="bg-white rounded-xl border border-gray-200 p-6">
//             <div className="flex items-center justify-between mb-5 flex-wrap gap-4">
//               <div className="flex items-center gap-3">
//                 <div className="p-2 bg-purple-100 rounded-lg">
//                   <FiActivity className="text-purple-600" size={20} />
//                 </div>
//                 <h3 className="text-lg font-semibold text-gray-900">
//                   Run History
//                 </h3>
//               </div>

//               {/* Filter Buttons */}
//               <div className="flex gap-2 bg-gray-100 rounded-lg p-1 border border-gray-200">
//                 {[
//                   {
//                     key: "upcoming",
//                     label: "Upcoming",
//                     count: counts.upcoming,
//                     icon: <FiTrendingUp size={14} />,
//                   },
//                   {
//                     key: "passed",
//                     label: "Passed",
//                     count: counts.passed,
//                     icon: <FiCheckCircle size={14} />,
//                   },
//                   {
//                     key: "all",
//                     label: "All",
//                     count: runs.length,
//                     icon: <FiActivity size={14} />,
//                   },
//                 ].map(({ key, label, count, icon }) => (
//                   <button
//                     key={key}
//                     onClick={() => setRunFilter(key)}
//                     className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 flex items-center gap-2 ${
//                       runFilter === key
//                         ? "bg-white text-purple-700 shadow-md border border-purple-200"
//                         : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
//                     }`}
//                   >
//                     {icon}
//                     {label}
//                     <span
//                       className={`px-2 py-0.5 rounded-full text-xs ${
//                         runFilter === key
//                           ? "bg-purple-100 text-purple-700"
//                           : "bg-gray-200 text-gray-600"
//                       }`}
//                     >
//                       {count}
//                     </span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {filteredRuns.length === 0 ? (
//               <div className="text-center py-8 text-gray-500">
//                 <FiActivity className="mx-auto text-gray-400 mb-2" size={32} />
//                 <p>No runs found for this filter.</p>
//               </div>
//             ) : (
//               <div className="space-y-2 max-h-96 overflow-y-auto">
//                 {filteredRuns.map((run, i) => (
//                   <RunHistoryItem key={i} run={run} />
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     );
//   }
//   const getRangeForMode = (mode, baseDate = new Date()) => {
//     const base = new Date(baseDate);

//     if (mode === "weekly") {
//       // 7-day window starting from base's start-of-day
//       const start = new Date(
//         base.getFullYear(),
//         base.getMonth(),
//         base.getDate(),
//       );
//       const end = new Date(start);
//       end.setDate(start.getDate() + 6);

//       return {
//         startStr: start.toISOString().split("T")[0],
//         endStr: end.toISOString().split("T")[0],
//       };
//     }

//     // Monthly view – 31 days inclusive
//     const start = new Date(base.getFullYear(), base.getMonth(), 1);

//     const end = new Date(base.getFullYear(), base.getMonth() + 1, 0);

//     return {
//       startStr: start.toISOString().split("T")[0],
//       endStr: end.toISOString().split("T")[0],
//     };
//   };
//   const applyCurrentRange = (mode = viewMode) => {
//     const now = new Date();
//     now.setDate(1);
//     setCurrentMonth(now);

//     const { startStr, endStr } = getRangeForMode(mode, now);
//     setStartDate(startStr);
//     setEndDate(endStr);
//     setDateError("");
//   };

//   useEffect(() => {
//     setPage(1);
//     fetchScheduleData(1);
//   }, [startDate, endDate]);

//   // const shiftRange = (direction) => {
//   //   const base = new Date(currentMonth);
//   //   base.setDate(1); // always safe

//   //   if (viewMode === "weekly") {
//   //     base.setDate(base.getDate() + (direction === "prev" ? -7 : 7));
//   //   } else {
//   //     base.setMonth(base.getMonth() + (direction === "prev" ? -1 : 1));
//   //   }

//   //   setCurrentMonth(base);

//   //   const { startStr, endStr } = getRangeForMode(viewMode, base);
//   //   setStartDate(startStr);
//   //   setEndDate(endStr);
//   //   setDateError("");
//   // };

//   const getDaysDifference = (start, end) => {
//     const s = new Date(start);
//     const e = new Date(end);
//     s.setHours(0, 0, 0, 0);
//     e.setHours(0, 0, 0, 0);
//     return Math.floor((e - s) / 86400000) + 1;
//   };

//   const shiftRange = (direction) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     // 1. Create a base date from the current state
//     let targetDate = new Date(currentMonth);
//     targetDate.setDate(1);

//     if (direction === "prev") {
//       // 2. Calculate what the previous date would be
//       if (viewMode === "weekly") {
//         targetDate.setDate(targetDate.getDate() - 7);
//       } else {
//         targetDate.setMonth(targetDate.getMonth() - 1);
//       }

//       // 3. Stop if the user tries to go before the current month
//       const currentMonthStart = new Date(
//         today.getFullYear(),
//         today.getMonth(),
//         1,
//       );
//       if (targetDate < currentMonthStart) {
//         return;
//       }
//     } else {
//       // 4. Handle "Next" direction
//       if (viewMode === "weekly") {
//         targetDate.setDate(targetDate.getDate() + 7);
//       } else {
//         targetDate.setMonth(targetDate.getMonth() + 1);
//       }
//     }

//     // 5. Update state with the confirmed target date
//     setCurrentMonth(targetDate);

//     const { startStr, endStr } = getRangeForMode(viewMode, targetDate);
//     setStartDate(startStr);
//     setEndDate(endStr);
//     setDateError("");
//   };
//   // Validate date range - only check max 30 days when sending to API
//   const validateDateRange = (start, end) => {
//     if (!start || !end) {
//       setDateError("Please select both start and end dates");
//       return false;
//     }

//     if (new Date(start) > new Date(end)) {
//       setDateError("Start date must be before end date");
//       return false;
//     }

//     const days = getDaysDifference(start, end);

//     // Only enforce max 31 days restriction when sending to backend
//     if (days > 730) {
//       setDateError("Date range cannot exceed 730 days");
//       return false;
//     }

//     setDateError("");
//     return true;
//   };

//   // Fetch data from API
//   // Fetch data from API
//   const fetchScheduleData = async (pageNumber = page) => {
//     // ✅ FIX: Check if pageNumber is an object (the React Event).
//     // If it is, or if it's not a number, fallback to the current 'page' state.
//     const activePage = typeof pageNumber === "number" ? pageNumber : page;

//     if (!validateDateRange(startDate, endDate)) return;

//     // console.log(activePage, startDate, endDate); // Use activePage here
//     if (!token) {
//       setError("Authentication token not found. Please login again.");
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       const requestBody = {
//         startDate,
//         endDate,
//         page: activePage, // ✅ Use the sanitized page number
//         limit,
//       };

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/calender/simulate/all`,
//         requestBody,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "x-client-type": "web",
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       const result = response.data;

//       // ✅ Safety Check for the result console log too
//       // console.log("Fetched schedule data:", result);
//       // console.log(getObjectSizeSafe(result));

//       if (result?.success) {
//         setData(result.data || []);
//         setPagination(result.pagination);
//         setPage(result.pagination.page);
//       } else {
//         setData([]);
//       }
//     } catch (err) {
//       console.error("Fetch schedule data error:", err);
//       setError(
//         err.message || "Failed to fetch schedule data. Please try again.",
//       );
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchStats = async () => {
//     if (!validateDateRange(startDate, endDate)) return;

//     if (!token) {
//       return;
//     }

//     setStatsLoading(true);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/calender/simulate/stat/all`,
//         { startDate, endDate },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "x-client-type": "web",
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       const result = response.data;
//       if (result?.success && result.data) {
//         const d = result.data;
//         setStats({
//           totalSchedules: d.totalSchedules || 0,
//           activeSchedules: d.status?.active || 0,
//           totalDevices: d.totalDevices || 0,
//           upcomingRuns: d.runs?.upcoming || 0,
//         });
//       } else {
//         setStats({
//           totalSchedules: 0,
//           activeSchedules: 0,
//           totalDevices: 0,
//           upcomingRuns: 0,
//         });
//       }
//     } catch (e) {
//       setStats({
//         totalSchedules: 0,
//         activeSchedules: 0,
//         totalDevices: 0,
//         upcomingRuns: 0,
//       });
//     } finally {
//       setStatsLoading(false);
//     }
//   };

//   // Load data on mount and when date range changes
//   // Note: viewMode is only for UI display, not for API calls
//   useEffect(() => {
//     if (startDate && endDate && token) {
//       const timer = setTimeout(() => {
//         fetchScheduleData();
//         fetchStats();
//       }, 300); // Debounce API calls

//       return () => clearTimeout(timer);
//     }
//   }, [startDate, endDate, token]); // Removed viewMode - API uses single endpoint

//   // Removed separate date input handlers - using only calendar picker now

//   // Removed date restrictions - users can select any dates (past or future)
//   // Only restriction is max 30 days range when sending to API

//   const columns = [
//     {
//       header: "Schedule ID",
//       cell: ({ row }) => {
//         const value = row.original.scheduleName || "";
//         return (
//           <div className="flex items-center gap-2">
//             <div className="p-2 bg-blue-100 rounded-lg">
//               <FiCalendar className="text-blue-600" size={16} />
//             </div>
//             <div>
//               <p className="font-semibold text-gray-900">
//                 {value.slice(-8) || "N/A"}
//               </p>
//               {value.length > 8 && (
//                 <p className="text-xs text-gray-500 font-mono">
//                   {value.slice(0, 12)}...
//                 </p>
//               )}
//             </div>
//           </div>
//         );
//       },
//     },
//     {
//       header: "Status",
//       cell: ({ row }) => (
//         <div className="flex items-center gap-2">
//           <span
//             className={`px-3 py-1.5 text-xs font-medium rounded-full ${
//               row.original.status === "active"
//                 ? "bg-emerald-100 text-emerald-700 border border-emerald-200"
//                 : "bg-gray-100 text-gray-700 border border-gray-200"
//             }`}
//           >
//             {row.original.status === "active" ? (
//               <span className="flex items-center gap-1">
//                 <FiCheckCircle size={12} /> Active
//               </span>
//             ) : (
//               <span className="flex items-center gap-1">
//                 <FiXCircle size={12} /> Inactive
//               </span>
//             )}
//           </span>
//         </div>
//       ),
//     },
//     {
//       header: "Schedule Type",
//       cell: ({ row }) => (
//         <div className="flex items-center gap-2">
//           <div className="p-1.5 bg-purple-100 rounded-md">
//             <FiClock className="text-purple-600" size={14} />
//           </div>
//           <span className="font-medium text-gray-700 capitalize">
//             {row.original.when?.scheduleType || "N/A"}
//           </span>
//         </div>
//       ),
//     },
//     // {
//     //   header: "Time & Timezone",
//     //   cell: ({ row }) => (
//     //     <div className="space-y-1">
//     //       <div className="flex items-center gap-2">
//     //         <FiClock className="text-gray-400" size={14} />
//     //         <p className="font-semibold text-gray-900">
//     //           {row.original.when?.exactTime || "N/A"}
//     //         </p>
//     //       </div>
//     //       <p className="text-xs text-gray-500 pl-6">
//     //         {row.original.when?.timezone || "N/A"}
//     //       </p>
//     //     </div>
//     //   ),
//     // },
//     {
//       header: "Devices",
//       cell: ({ row }) => (
//         <div className="flex items-center gap-2">
//           <div className="p-1.5 bg-indigo-100 rounded-md">
//             <FiServer className="text-indigo-600" size={14} />
//           </div>
//           <span className="font-semibold text-gray-900">
//             {Number(row.original.actions?.length) || 0}
//           </span>
//           <span className="text-xs text-gray-500">
//             device{Number(row.original.actions?.length) !== 1 ? "s" : ""}
//           </span>
//         </div>
//       ),
//     },
//     {
//       header: "Next Run Date", // Changed header name for clarity
//       cell: ({ row }) => {
//         // Extract the timestamp from the end of the ID
//         const idParts = row.id.split("_");
//         const timestamp = parseInt(idParts[idParts.length - 1]);

//         if (isNaN(timestamp)) return <span>N/A</span>;

//         const runDate = new Date(timestamp);

//         return (
//           <div className="text-sm">
//             <div className="flex items-center gap-1.5 text-gray-900 font-semibold">
//               <FiClock className="text-blue-500" size={14} />
//               {runDate.toLocaleDateString("en-US", {
//                 month: "short",
//                 day: "numeric",
//                 year: "numeric",
//               })}
//             </div>
//             <p className="text-xs text-gray-500 mt-0.5 ml-5">
//               {runDate.toLocaleTimeString("en-US", {
//                 hour: "2-digit",
//                 minute: "2-digit",
//                 hour12: true,
//               })}
//             </p>
//           </div>
//         );
//       },
//     },
//     {
//       header: "Actions",
//       cell: ({ row }) => (
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             // TanStack uses row.id which we mapped to backend.id
//             setExpanded((prev) => ({ ...prev, [row.id]: !prev[row.id] }));
//           }}
//           className="flex items-center gap-1.5 text-sm font-medium text-gray-700"
//         >
//           {expanded[row.id] ? (
//             <>
//               <FiChevronUp size={16} /> Hide
//             </>
//           ) : (
//             <>
//               <FiChevronDown size={16} /> Details
//             </>
//           )}
//         </button>
//       ),
//     },
//   ];
//   const table = useReactTable({
//     data,
//     columns,
//     // ✅ Use the new unique ID from the backend
//     getRowId: (row) => row.id,
//     getCoreRowModel: getCoreRowModel(),
//   });

//   const daysSelected =
//     startDate && endDate ? getDaysDifference(startDate, endDate) : 0;

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-6">
//       <div className="max-w-7xl mx-auto space-y-6">
//         {/* Header Section */}
//         <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6">
//           <div className="flex items-center justify-between mb-4">
//             <div>
//               <h1 className="text-3xl font-bold text-gray-900 mb-2">
//                 Schedule Dashboard
//               </h1>
//               <p className="text-gray-600">
//                 Manage and monitor your automated device schedules
//               </p>
//             </div>
//             <div className="p-4 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl">
//               <FiActivity className="text-white" size={28} />
//             </div>
//           </div>

//           {/* Date Range Picker */}
//           <div className="mt-6 pt-6 border-t border-gray-200">
//             <div className="flex flex-wrap items-end gap-4">
//               <div className="flex items-center gap-3">
//                 <FiFilter className="text-gray-600" size={20} />
//                 <h3 className="text-lg font-semibold text-gray-900">
//                   Date Range Filter
//                 </h3>
//               </div>

//               {/* Custom Calendar Date Picker Button */}
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={() => {
//                     setTempStartDate(startDate);
//                     setTempEndDate(startDate);
//                     setCurrentMonth(new Date(startDate || new Date()));
//                     setShowDatePicker(true);
//                   }}
//                   className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 flex items-center gap-2 font-medium shadow-md hover:shadow-lg"
//                 >
//                   <FiCalendar size={18} />
//                   Select Date Range
//                 </button>
//                 {startDate && endDate && (
//                   <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm">
//                     <span className="font-medium text-gray-900">
//                       {new Date(startDate).toLocaleDateString("en-US", {
//                         month: "short",
//                         day: "numeric",
//                       })}{" "}
//                       -{" "}
//                       {new Date(endDate).toLocaleDateString("en-US", {
//                         month: "short",
//                         day: "numeric",
//                         year: "numeric",
//                       })}
//                     </span>
//                   </div>
//                 )}
//               </div>

//               {/* View mode toggle + quick navigation */}
//               <div className="flex items-center gap-3 ml-auto">
//                 {/* {/* <div className="flex items-center bg-gray-100 rounded-full p-1 border border-gray-200 text-xs">
//                   {[ "monthly"].map((mode) => (
//                     <button
//                       key={mode}
//                       onClick={() => {
//                         setViewMode(mode);
//                         applyCurrentRange(mode);
//                       }}
//                       className={`px-3 py-1 rounded-full font-medium transition-colors ${
//                         viewMode === mode
//                           ? "bg-white text-blue-700 shadow-sm"
//                           : "text-gray-600 hover:text-gray-900"
//                       }`}
//                     >
//                       {mode === "weekly" ? "Weekly" : "Monthly"}
//                     </button>
//                   ))}
//                 </div> */}
//                 {/* Refresh button */}

//                 <div className="flex items-center gap-2 text-xs">
//                   <button
//                     type="button"
//                     onClick={() => shiftRange("prev")}
//                     disabled={
//                       new Date(currentMonth).getMonth() <=
//                         new Date().getMonth() &&
//                       new Date(currentMonth).getFullYear() <=
//                         new Date().getFullYear()
//                     }
//                     className="flex items-center gap-1 px-2 py-1 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-100"
//                   >
//                     <FiChevronLeft size={14} />
//                     <span>Prev</span>
//                   </button>
//                   <button
//                     type="button"
//                     onClick={() => applyCurrentRange()}
//                     className="px-3 py-1 rounded-lg bg-gray-100 text-gray-800 hover:bg-gray-200 font-medium"
//                   >
//                     This {viewMode === "weekly" ? "Week" : "Month"}
//                   </button>
//                   <button
//                     type="button"
//                     onClick={() => shiftRange("next")}
//                     className="flex items-center gap-1 px-2 py-1 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-100"
//                   >
//                     <span>Next</span>
//                     <FiChevronRight size={14} />
//                   </button>
//                   <button
//                     onClick={() => fetchScheduleData(1)} // ✅ Explicitly pass page 1, ignore the event
//                     disabled={loading || !!dateError}
//                     className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-2 font-medium"
//                   >
//                     {loading ? (
//                       <>
//                         <FiLoader className="animate-spin" size={16} />
//                       </>
//                     ) : (
//                       <>
//                         <FiRefreshCw size={16} />
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Date Range Info and Error */}
//             <div className="mt-4 flex items-center justify-between flex-wrap gap-2">
//               <div className="flex items-center gap-4 text-sm">
//                 {startDate && endDate && !dateError && (
//                   <div className="flex items-center gap-2 text-gray-600">
//                     <FiCalendar size={16} />
//                     <span>
//                       Selected:{" "}
//                       <span className="font-semibold">{daysSelected}</span> day
//                       {daysSelected !== 1 ? "s" : ""}({startDate} to {endDate})
//                     </span>
//                   </div>
//                 )}
//               </div>

//               {dateError && (
//                 <div className="flex items-center gap-2 text-red-600 text-sm">
//                   <FiAlertCircle size={16} />
//                   <span>{dateError}</span>
//                 </div>
//               )}
//             </div>

//             {/* Error Message */}
//             {error && (
//               <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center gap-3">
//                 <FiAlertCircle className="text-red-600" size={20} />
//                 <div>
//                   <p className="font-semibold text-red-900">Error</p>
//                   <p className="text-sm text-red-700">{error}</p>
//                 </div>
//                 <button
//                   onClick={() => setError(null)}
//                   className="ml-auto text-red-600 hover:text-red-800"
//                 >
//                   <FiXCircle size={20} />
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Custom Date Range Picker Modal */}
//         {/* {showDatePicker && (
//           <CustomDateRangePicker
//             startDate={tempStartDate}
//             endDate={tempEndDate}
//             currentMonth={currentMonth}
//             onStartDateChange={setTempStartDate}
//             onEndDateChange={setTempEndDate}
//             onMonthChange={setCurrentMonth}
//             onClose={() => setShowDatePicker(false)}
//             onApply={() => {
//               const days = getDaysDifference(tempStartDate, tempEndDate);
//               // Only check max 31 days - no minimum restriction
//               if (days > 730) {
//                 setDateError("Date range cannot exceed 730 days");
//                 return;
//               }
//               setStartDate(tempStartDate);
//               setEndDate(tempEndDate);
//               setDateError("");
//               setShowDatePicker(false);
//             }}
//           />
//         )} */}
//         {showDatePicker && (
//           <CustomDateRangePicker
//             startDate={tempStartDate}
//             endDate={tempEndDate}
//             currentMonth={currentMonth}
//             onStartDateChange={setTempStartDate}
//             onEndDateChange={setTempEndDate}
//             onMonthChange={setCurrentMonth} // Month/year navigation updates currentMonth
//             onClose={() => setShowDatePicker(false)}
//             onApply={() => {
//               const days = getDaysDifference(tempStartDate, tempEndDate);
//               // Max 730 days allowed
//               if (days > 730) {
//                 setDateError("Date range cannot exceed 730 days");
//                 return;
//               }
//               setStartDate(tempStartDate);
//               setEndDate(tempEndDate);
//               setDateError("");
//               setShowDatePicker(false);
//             }}
//           />
//         )}

//         {/* Statistics Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//           <StatCard
//             icon={<FiCalendar className="text-blue-600" size={24} />}
//             label="Total Schedules"
//             value={stats.totalSchedules}
//             bgColor="bg-blue-50"
//             borderColor="border-blue-200"
//             loading={statsLoading}
//           />
//           <StatCard
//             icon={<FiCheckCircle className="text-emerald-600" size={24} />}
//             label="Active Schedules"
//             value={stats.activeSchedules}
//             bgColor="bg-emerald-50"
//             borderColor="border-emerald-200"
//             loading={statsLoading}
//           />
//           <StatCard
//             icon={<FiServer className="text-indigo-600" size={24} />}
//             label="Total Devices"
//             value={stats.totalDevices}
//             bgColor="bg-indigo-50"
//             borderColor="border-indigo-200"
//             loading={statsLoading}
//           />
//           <StatCard
//             icon={<FiTrendingUp className="text-purple-600" size={24} />}
//             label="Upcoming Cron Jobs"
//             value={stats.upcomingRuns}
//             bgColor="bg-purple-50"
//             borderColor="border-purple-200"
//             loading={statsLoading}
//           />
//         </div>

//         {/* Main Table Card */}
//         <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
//           <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
//             <div className="flex items-center justify-between">
//               <div>
//                 <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
//                   <FiZap className="text-yellow-500" size={20} />
//                   Schedule Details
//                 </h2>
//                 <p className="text-sm text-gray-600 mt-1">
//                   {loading
//                     ? "Loading schedules..."
//                     : `Showing ${data.length} schedule${
//                         data.length !== 1 ? "s" : ""
//                       }`}
//                 </p>
//               </div>
//               {data.length > 0 && (
//                 <div className="text-sm text-gray-600">
//                   Total:{" "}
//                   <span className="font-semibold text-gray-900">
//                     {data.length}
//                   </span>
//                 </div>
//               )}
//             </div>
//           </div>

//           {loading ? (
//             <div className="text-center py-16">
//               {/* <FiLoader
//                 className="mx-auto text-blue-600 animate-spin"
//                 size={48}
//               /> */}
//               {/* <p className="mt-4 text-gray-600">Loading schedule data...</p> */}
//               <Loader />
//             </div>
//           ) : error && !data.length ? (
//             <div className="text-center py-16">
//               <FiAlertCircle className="mx-auto text-red-500" size={48} />
//               <p className="mt-4 text-gray-600">{error}</p>
//               <button
//                 onClick={fetchScheduleData}
//                 className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//               >
//                 Try Again
//               </button>
//             </div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="w-full">
//                 <thead className="bg-gray-50 border-b border-gray-200">
//                   {table.getHeaderGroups().map((hg) => (
//                     <tr key={hg}>
//                       {hg.headers.map((header) => (
//                         <th
//                           key={header.id}
//                           className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
//                         >
//                           {flexRender(
//                             header.column.columnDef.header,
//                             header.getContext(),
//                           )}
//                         </th>
//                       ))}
//                     </tr>
//                   ))}
//                 </thead>

//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {table.getRowModel().rows.map((row) => (
//                     /* ✅ This Fragment key is what prevents the "Visual Duplicates" */
//                     <Fragment key={row.id}>
//                       <tr
//                         className={`${
//                           expanded[row.id]
//                             ? "bg-blue-50/30"
//                             : "hover:bg-gray-50"
//                         } transition-colors cursor-pointer`}
//                         onClick={() =>
//                           setExpanded((prev) => ({
//                             ...prev,
//                             [row.id]: !prev[row.id],
//                           }))
//                         }
//                       >
//                         {row.getVisibleCells().map((cell) => (
//                           <td
//                             key={cell.id}
//                             className="px-6 py-4 whitespace-nowrap"
//                           >
//                             {flexRender(
//                               cell.column.columnDef.cell,
//                               cell.getContext(),
//                             )}
//                           </td>
//                         ))}
//                       </tr>

//                       {/* Expanded Details Row */}
//                       {expanded[row.id] && (
//                         <tr>
//                           <td
//                             colSpan={columns.length}
//                             className="px-6 py-8 bg-gray-50/50"
//                           >
//                             <div className="animate-in slide-in-from-top-2 duration-300">
//                               <ExpandedSchedule schedule={row.original} />
//                             </div>
//                           </td>
//                         </tr>
//                       )}
//                     </Fragment>
//                   ))}
//                 </tbody>
//               </table>
//               <div className="flex justify-center mt-4 mb-4">
//                 <Pagination
//                   count={pagination.totalPages || 1}
//                   page={page}
//                   onChange={(e, v) => fetchScheduleData(v)}
//                   color="primary"
//                   shape="rounded"
//                 />
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ---------------- Statistics Card Component ---------------- */
// function StatCard({ icon, label, value, bgColor, borderColor, loading }) {
//   return (
//     <div
//       className={`${bgColor} ${borderColor} border-2 rounded-xl p-5 hover:shadow-lg transition-all duration-200 transform hover:-translate-y-1`}
//     >
//       <div className="flex items-center justify-between mb-3">
//         <div className={`p-2 ${bgColor} rounded-lg`}>{icon}</div>
//       </div>
//       <div>
//         <p className="text-sm font-medium text-gray-600 mb-1">{label}</p>
//         {loading ? (
//           <div className="flex items-center gap-2">
//             <FiLoader className="animate-spin text-gray-400" size={20} />
//             <span className="text-3xl font-bold text-gray-400">---</span>
//           </div>
//         ) : (
//           <p className="text-3xl font-bold text-gray-900">{value}</p>
//         )}
//       </div>
//     </div>
//   );
// }

// /* ---------------- Expanded Schedule Card ---------------- */
// function ExpandedSchedule({ schedule }) {
//   const [runFilter, setRunFilter] = useState("upcoming");

//   const runs = schedule.runs || [];
//   const filteredRuns = runs.filter(
//     (r) => runFilter === "all" || r.date_status === runFilter,
//   );

//   const counts = {
//     passed: runs.filter((r) => r.date_status === "passed").length,
//     upcoming: runs.filter((r) => r.date_status === "upcoming").length,
//   };

//   return (
//     <div className="space-y-6 animate-fade-in">
//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//         <InfoCard
//           icon={<FiClock className="text-blue-600" size={20} />}
//           label="Next Run"
//           value={
//             schedule.when?.nextRunAt ? Date(schedule.when.nextRunAt) : "N/A"
//           }
//           bgColor="bg-blue-50"
//           borderColor="border-blue-200"
//         />
//         <InfoCard
//           icon={<FiCalendar className="text-purple-600" size={20} />}
//           label="Round to Closest"
//           value={`${schedule?.roundtoclosest ?? 0} Min`}
//           bgColor="bg-purple-50"
//           borderColor="border-purple-200"
//         />
//         {/* <InfoCard
//           icon={<FiZap className="text-yellow-600" size={20} />}
//           label="Timezone"
//           value={schedule.when?.timezone || "N/A"}
//           bgColor="bg-yellow-50"
//           borderColor="border-yellow-200"
//         /> */}
//         <InfoCard
//           icon={<FiRefreshCw className="text-indigo-600" size={20} />}
//           label="Schedule Type"
//           value={
//             schedule.when?.scheduleType
//               ? schedule.when.calenderType.charAt(0).toUpperCase() +
//                 schedule.when.calenderType.slice(1)
//               : "N/A"
//           }
//           bgColor="bg-indigo-50"
//           borderColor="border-indigo-200"
//         />
//         {typeof schedule.smartRestore === "boolean" && (
//           <InfoCard
//             icon={<FiRefreshCw className="text-emerald-600" size={20} />}
//             label="Smart Restore"
//             value={schedule.smartRestore ? "On" : "Off"}
//             bgColor="bg-emerald-50"
//             borderColor="border-emerald-200"
//           />
//         )}
//       </div>

//       {/* Devices Section */}
//       {schedule.actions && schedule.actions.length > 0 && (
//         <div className="bg-white rounded-xl border border-gray-200 p-6">
//           <div className="flex items-center gap-3 mb-5">
//             <div className="p-2 bg-indigo-100 rounded-lg">
//               <FiServer className="text-indigo-600" size={20} />
//             </div>
//             <h3 className="text-lg font-semibold text-gray-900">
//               Devices ({schedule.actions.length})
//             </h3>
//           </div>
//           <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
//             {schedule.actions.map((d) => (
//               <DeviceCard key={d._id || Math.random()} device={d} />
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Run History Section */}
//       {runs.length > 0 && (
//         <div className="bg-white rounded-xl border border-gray-200 p-6">
//           <div className="flex items-center justify-between mb-5 flex-wrap gap-4">
//             <div className="flex items-center gap-3">
//               <div className="p-2 bg-purple-100 rounded-lg">
//                 <FiActivity className="text-purple-600" size={20} />
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Run History
//               </h3>
//             </div>

//             {/* Filter Buttons */}
//             <div className="flex gap-2 bg-gray-100 rounded-lg p-1 border border-gray-200">
//               {[
//                 {
//                   key: "upcoming",
//                   label: "Upcoming",
//                   count: counts.upcoming,
//                   icon: <FiTrendingUp size={14} />,
//                 },
//                 {
//                   key: "passed",
//                   label: "Passed",
//                   count: counts.passed,
//                   icon: <FiCheckCircle size={14} />,
//                 },
//                 {
//                   key: "all",
//                   label: "All",
//                   count: runs.length,
//                   icon: <FiActivity size={14} />,
//                 },
//               ].map(({ key, label, count, icon }) => (
//                 <button
//                   key={key}
//                   onClick={() => setRunFilter(key)}
//                   className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 flex items-center gap-2 ${
//                     runFilter === key
//                       ? "bg-white text-purple-700 shadow-md border border-purple-200"
//                       : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
//                   }`}
//                 >
//                   {icon}
//                   {label}
//                   <span
//                     className={`px-2 py-0.5 rounded-full text-xs ${
//                       runFilter === key
//                         ? "bg-purple-100 text-purple-700"
//                         : "bg-gray-200 text-gray-600"
//                     }`}
//                   >
//                     {count}
//                   </span>
//                 </button>
//               ))}
//             </div>
//           </div>

//           {filteredRuns.length === 0 ? (
//             <div className="text-center py-8 text-gray-500">
//               <FiActivity className="mx-auto text-gray-400 mb-2" size={32} />
//               <p>No runs found for this filter.</p>
//             </div>
//           ) : (
//             <div className="space-y-2 max-h-96 overflow-y-auto">
//               {filteredRuns.map((run, i) => (
//                 <RunHistoryItem key={i} run={run} />
//               ))}
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ---------------- Device Card Component ---------------- */
// function DeviceCard({ device }) {
//   return (
//     <div className="bg-gradient-to-br from-white to-gray-50 border-2 rounded-xl p-5 hover:shadow-lg transition-all duration-200 border-gray-200">
//       <div className="flex items-center justify-between mb-4">
//         <div className="flex items-center gap-3">
//           <div
//             className={`p-2 rounded-lg ${
//               device.deviceOn ? "bg-emerald-100" : "bg-gray-200"
//             }`}
//           >
//             {device.deviceOn ? (
//               <FiPower className="text-emerald-600" size={18} />
//             ) : (
//               <FiPower className="text-gray-600" size={18} />
//             )}
//           </div>
//           <div>
//             <span className="font-bold text-gray-900 break-all block max-w-xs leading-snug">
//               {device.deviceName || "N/A"}
//             <p className="text-xs text-gray-500">{device.deviceId}</p>
//             </span>
//           </div>
//         </div>
//         <span
//           className={`px-3 py-1 text-xs font-semibold rounded-full ${
//             device.deviceOn
//               ? "bg-emerald-100 text-emerald-700 border border-emerald-300"
//               : "bg-gray-100 text-gray-700 border border-gray-300"
//           }`}
//         >
//           {device.deviceOn ? "ON" : "OFF"}
//         </span>
//       </div>

//       <div className="space-y-2">
//         <div className="flex items-center justify-between text-sm">
//           <span className="text-gray-600 flex items-center gap-2">
//             <FiCheckCircle
//               className={device.supported ? "text-emerald-500" : "text-red-500"}
//               size={14}
//             />
//             Supported
//           </span>
//           <span
//             className={`font-medium ${
//               device.supported ? "text-emerald-700" : "text-red-700"
//             }`}
//           >
//             {device.supported ? "Yes" : "No"}
//           </span>
//         </div>

//         {device.executedAt && (
//           <div className="flex items-center justify-between text-sm">
//             <span className="text-gray-600 flex items-center gap-2">
//               <FiClock size={14} />
//               Executed At
//             </span>
//             <span className="font-medium text-gray-900 text-xs">
//               {formatDate(device.executedAt)}
//             </span>
//           </div>
//         )}

//         {device.brightnessLevel !== null &&
//           device.brightnessLevel !== undefined &&
//           device.brightnessSupported && (
//             <div className="flex items-center justify-between text-sm">
//               <span className="text-gray-600 flex items-center gap-2">
//                 <FiSun size={14} />
//                 Brightness
//               </span>
//               <span className="font-medium text-gray-900">
//                 {device.brightnessLevel}%
//               </span>
//             </div>
//           )}

//         <div className="flex items-center justify-between text-sm pt-2 border-t border-gray-200">
//           <span className="text-gray-600 flex items-center gap-2">
//             <FiRefreshCw size={14} />
//             Allowed Retries
//           </span>
//           <span className="font-medium text-gray-900">
//             {device.allowedRetries || 0}
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ---------------- Run History Item Component ---------------- */
// function RunHistoryItem({ run }) {
//   const isPassed = run.date_status === "passed";

//   return (
//     <div
//       className={`flex items-center justify-between p-4 rounded-lg border-2 transition-all duration-200 hover:shadow-md ${
//         isPassed
//           ? "bg-gray-50 border-gray-200"
//           : "bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200"
//       }`}
//     >
//       <div className="flex items-center gap-4">
//         <div
//           className={`p-2 rounded-lg ${
//             isPassed ? "bg-gray-200" : "bg-blue-100"
//           }`}
//         >
//           {isPassed ? (
//             <FiCheckCircle className="text-gray-600" size={18} />
//           ) : (
//             <FiClock className="text-blue-600" size={18} />
//           )}
//         </div>
//         <div>
//           <p className="font-semibold text-gray-900">
//             {/* {formatDate(run.nextRunAt)} */}
//             {run.nextRunAt}
//           </p>
//           <p className="text-xs text-gray-500 mt-0.5">
//             {new Date(run.nextRunAt).toLocaleDateString("en-US", {
//               weekday: "long",
//             })}
//           </p>
//         </div>
//       </div>
//       <span
//         className={`px-3 py-1.5 text-xs font-semibold rounded-full ${
//           isPassed
//             ? "bg-gray-200 text-gray-700 border border-gray-300"
//             : "bg-blue-100 text-blue-700 border border-blue-300"
//         }`}
//       >
//         {run.date_status
//           ? run.date_status.charAt(0).toUpperCase() + run.date_status.slice(1)
//           : "N/A"}
//       </span>
//     </div>
//   );
// }

// /* ---------------- Info Card Component ---------------- */
// function InfoCard({ icon, label, value, bgColor, borderColor }) {
//   return (
//     <div className={`${bgColor} ${borderColor} border-2 rounded-xl p-4`}>
//       <div className="flex items-center gap-3 mb-2">
//         {icon}
//         <p className="text-xs font-medium text-gray-600 uppercase tracking-wide">
//           {label}
//         </p>
//       </div>
//       <p className="text-lg font-bold text-gray-900">{value}</p>
//     </div>
//   );
// }

// /* ---------------- Custom Date Range Picker Component ---------------- */
// // function CustomDateRangePicker({
// //   startDate,
// //   endDate,
// //   currentMonth,
// //   onStartDateChange,
// //   onEndDateChange,
// //   onMonthChange,
// //   onClose,
// //   onApply,
// // }) {
// //   // Helper to format date as YYYY-MM-DD
// //   const getDateString = (date) => {
// //     const year = date.getFullYear();
// //     const month = String(date.getMonth() + 1).padStart(2, "0");
// //     const day = String(date.getDate()).padStart(2, "0");
// //     return `${year}-${month}-${day}`;
// //   };

// //   const handleDateClick = (date) => {
// //     if (!date) return;
// //     const dateStr = getDateString(date);

// //     if (!startDate || (startDate && endDate)) {
// //       onStartDateChange(dateStr);
// //       onEndDateChange("");
// //       return;
// //     }

// //     if (dateStr < startDate) {
// //       onEndDateChange(startDate);
// //       onStartDateChange(dateStr);
// //     } else {
// //       onEndDateChange(dateStr);
// //     }
// //   };

// //   const today = new Date();
// //   today.setHours(0, 0, 0, 0);

// //   const year = currentMonth.getFullYear();
// //   const month = currentMonth.getMonth();

// //   const firstDay = new Date(year, month, 1);
// //   const lastDay = new Date(year, month + 1, 0);
// //   const daysInMonth = lastDay.getDate();
// //   const startingDayOfWeek = firstDay.getDay();

// //   // All days in the month grid
// //   const days = useMemo(() => {
// //     const dayArray = [];
// //     for (let i = 0; i < startingDayOfWeek; i++) {
// //       dayArray.push(null);
// //     }
// //     for (let day = 1; day <= daysInMonth; day++) {
// //       const date = new Date(year, month, day, 0, 0, 0, 0);
// //       dayArray.push(date);
// //     }
// //     return dayArray;
// //   }, [year, month, startingDayOfWeek, daysInMonth]);

// //   const isDateInRange = (date) => {
// //     if (!date || !startDate || !endDate) return false;
// //     const dateStr = getDateString(date);
// //     return dateStr >= startDate && dateStr <= endDate;
// //   };

// //   const isStartDate = (date) => {
// //     if (!date || !startDate) return false;
// //     return getDateString(date) === startDate;
// //   };

// //   const isEndDate = (date) => {
// //     if (!date || !endDate) return false;
// //     return getDateString(date) === endDate;
// //   };

// //   const changeMonth = (direction) => {
// //     const newMonth = new Date(currentMonth);
// //     newMonth.setMonth(currentMonth.getMonth() + direction);
// //     onMonthChange(newMonth);
// //   };

// //   const changeYear = (direction) => {
// //     const newMonth = new Date(currentMonth);
// //     newMonth.setFullYear(currentMonth.getFullYear() + direction);
// //     onMonthChange(newMonth);
// //   };

// //   const monthNames = [
// //     "January",
// //     "February",
// //     "March",
// //     "April",
// //     "May",
// //     "June",
// //     "July",
// //     "August",
// //     "September",
// //     "October",
// //     "November",
// //     "December",
// //   ];
// //   const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// //   return (
// //     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
// //       <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-auto">
// //         {/* Header */}
// //         <div className="flex items-center justify-between p-6 border-b border-gray-200">
// //           <div>
// //             <h3 className="text-xl font-bold text-gray-900">
// //               Select Date Range
// //             </h3>
// //             <p className="text-sm text-gray-600 mt-1">
// //               Choose start and end dates (max 730 days)
// //             </p>
// //           </div>
// //           <button
// //             onClick={onClose}
// //             className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
// //           >
// //             <FiX size={24} className="text-gray-600" />
// //           </button>
// //         </div>

// //         {/* Calendar */}
// //         <div className="p-6">
// //           {/* Month & Year Navigation */}
// //           <div className="flex items-center justify-between mb-6">
// //             <button
// //               onClick={() => changeYear(-1)}
// //               className="px-2 py-1 rounded hover:bg-gray-100 text-gray-600 font-semibold"
// //             >
// //               &lt;&lt; Year
// //             </button>

// //             <div className="flex items-center gap-2">
// //               <button
// //                 onClick={() => changeMonth(-1)}
// //                 className="p-2 hover:bg-gray-100 rounded-lg"
// //               >
// //                 <FiChevronLeft size={20} className="text-gray-600" />
// //               </button>

// //               <h4 className="text-lg font-semibold text-gray-900">
// //                 {monthNames[month]} {year}
// //               </h4>

// //               <button
// //                 onClick={() => changeMonth(1)}
// //                 className="p-2 hover:bg-gray-100 rounded-lg"
// //               >
// //                 <FiChevronRight size={20} className="text-gray-600" />
// //               </button>
// //             </div>

// //             <button
// //               onClick={() => changeYear(1)}
// //               className="px-2 py-1 rounded hover:bg-gray-100 text-gray-600 font-semibold"
// //             >
// //               Year &gt;&gt;
// //             </button>
// //           </div>

// //           {/* Day Names */}
// //           <div className="grid grid-cols-7 gap-1 mb-2">
// //             {dayNames.map((day) => (
// //               <div
// //                 key={day}
// //                 className="text-center text-xs font-semibold text-gray-600 py-2"
// //               >
// //                 {day}
// //               </div>
// //             ))}
// //           </div>

// //           {/* Calendar Grid */}
// //           <div className="grid grid-cols-7 gap-1">
// //             {days.map((date, index) => {
// //               if (!date)
// //                 return <div key={`empty-${index}`} className="aspect-square" />;

// //               const dateStr = getDateString(date);
// //               const isInRange = isDateInRange(date);
// //               const isStart = isStartDate(date);
// //               const isEnd = isEndDate(date);
// //               const todayStr = getDateString(today);
// //               const isToday = dateStr === todayStr;

// //               return (
// //                 <button
// //                   key={`${dateStr}-${index}`}
// //                   type="button"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     e.stopPropagation();
// //                     handleDateClick(date);
// //                   }}
// //                   className={`
// //                     aspect-square rounded-lg text-sm font-medium transition-all duration-200
// //                     hover:bg-blue-100 cursor-pointer active:scale-95
// //                     ${isToday ? "ring-2 ring-blue-500" : ""}
// //                     ${
// //                       isStart || isEnd
// //                         ? "bg-blue-600 text-white hover:bg-blue-700"
// //                         : isInRange
// //                           ? "bg-blue-100 text-blue-900"
// //                           : "hover:bg-gray-100 text-gray-800"
// //                     }
// //                   `}
// //                 >
// //                   {date.getDate()}
// //                 </button>
// //               );
// //             })}
// //           </div>

// //           {/* Apply Button */}
// //           <div className="mt-6 flex justify-end gap-2">
// //             <button
// //               onClick={onClose}
// //               className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
// //             >
// //               Cancel
// //             </button>
// //             <button
// //               onClick={onApply}
// //               className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
// //             >
// //               Apply
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }
// function CustomDateRangePicker({
//   startDate,
//   endDate,
//   currentMonth,
//   onStartDateChange,
//   onEndDateChange,
//   onMonthChange,
//   onClose,
//   onApply,
// }) {
//   // Helper to format date as YYYY-MM-DD
//   const getDateString = (date) => {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   const handleDateClick = (date) => {
//     if (!date) return;
//     const dateStr = getDateString(date);

//     if (!startDate || (startDate && endDate)) {
//       onStartDateChange(dateStr);
//       onEndDateChange("");
//       return;
//     }

//     if (dateStr < startDate) {
//       onEndDateChange(startDate);
//       onStartDateChange(dateStr);
//     } else {
//       onEndDateChange(dateStr);
//     }
//   };

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const year = currentMonth.getFullYear();
//   const month = currentMonth.getMonth();

//   const firstDay = new Date(year, month, 1);
//   const lastDay = new Date(year, month + 1, 0);
//   const daysInMonth = lastDay.getDate();
//   const startingDayOfWeek = firstDay.getDay();

//   // All days in the month grid
//   const days = useMemo(() => {
//     const dayArray = [];
//     for (let i = 0; i < startingDayOfWeek; i++) {
//       dayArray.push(null);
//     }
//     for (let day = 1; day <= daysInMonth; day++) {
//       const date = new Date(year, month, day, 0, 0, 0, 0);
//       dayArray.push(date);
//     }
//     return dayArray;
//   }, [year, month, startingDayOfWeek, daysInMonth]);

//   const isDateInRange = (date) => {
//     if (!date || !startDate || !endDate) return false;
//     const dateStr = getDateString(date);
//     return dateStr >= startDate && dateStr <= endDate;
//   };

//   const isStartDate = (date) => {
//     if (!date || !startDate) return false;
//     return getDateString(date) === startDate;
//   };

//   const isEndDate = (date) => {
//     if (!date || !endDate) return false;
//     return getDateString(date) === endDate;
//   };

//   const changeMonth = (direction) => {
//     const newMonth = new Date(currentMonth);
//     newMonth.setMonth(currentMonth.getMonth() + direction);

//     const minMonth = new Date(today.getFullYear(), today.getMonth(), 1);
//     if (direction === -1 && newMonth < minMonth) return;

//     onMonthChange(newMonth);
//   };

//   const changeYear = (direction) => {
//     const newMonth = new Date(currentMonth);
//     newMonth.setFullYear(currentMonth.getFullYear() + direction);

//     if (direction === -1 && newMonth.getFullYear() < today.getFullYear())
//       return;

//     onMonthChange(newMonth);
//   };

//   const monthNames = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];
//   const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-auto">
//         {/* Header */}
//         <div className="flex items-center justify-between p-6 border-b border-gray-200">
//           <div>
//             <h3 className="text-xl font-bold text-gray-900">
//               Select Date Range
//             </h3>
//             <p className="text-sm text-gray-600 mt-1">
//               Choose start and end dates (max 730 days)
//             </p>
//           </div>
//           <button
//             onClick={onClose}
//             className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//           >
//             <FiX size={24} className="text-gray-600" />
//           </button>
//         </div>

//         <div className="p-6">
//           {/* Month & Year Navigation */}
//           <div className="flex items-center justify-between mb-6">
//             <button
//               onClick={() => changeYear(-1)}
//               disabled={year <= today.getFullYear()}
//               className="px-2 py-1 rounded hover:bg-gray-100 text-gray-600 font-semibold disabled:opacity-20 disabled:cursor-not-allowed"
//             >
//               &lt;&lt; Year
//             </button>

//             <div className="flex items-center gap-2">
//               <button
//                 onClick={() => changeMonth(-1)}
//                 disabled={
//                   year <= today.getFullYear() && month <= today.getMonth()
//                 }
//                 className="p-2 hover:bg-gray-100 rounded-lg disabled:opacity-20 disabled:cursor-not-allowed"
//               >
//                 <FiChevronLeft size={20} className="text-gray-600" />
//               </button>

//               <h4 className="text-lg font-semibold text-gray-900">
//                 {monthNames[month]} {year}
//               </h4>

//               <button
//                 onClick={() => changeMonth(1)}
//                 className="p-2 hover:bg-gray-100 rounded-lg"
//               >
//                 <FiChevronRight size={20} className="text-gray-600" />
//               </button>
//             </div>

//             <button
//               onClick={() => changeYear(1)}
//               className="px-2 py-1 rounded hover:bg-gray-100 text-gray-600 font-semibold"
//             >
//               Year &gt;&gt;
//             </button>
//           </div>

//           {/* Day Names */}
//           <div className="grid grid-cols-7 gap-1 mb-2">
//             {dayNames.map((day) => (
//               <div
//                 key={day}
//                 className="text-center text-xs font-bold text-gray-500 py-2 uppercase tracking-wider"
//               >
//                 {day}
//               </div>
//             ))}
//           </div>

//           {/* Calendar Grid */}
//           {/* Calendar Grid */}
//           <div className="grid grid-cols-7 gap-1">
//             {days.map((date, index) => {
//               if (!date)
//                 return <div key={`empty-${index}`} className="aspect-square" />;

//               const isPast = date < today;
//               const dateStr = getDateString(date);
//               const isInRange = isDateInRange(date);
//               const isStart = isStartDate(date);
//               const isEnd = isEndDate(date);
//               const todayStr = getDateString(today);
//               const isToday = dateStr === todayStr;

//               return (
//                 <button
//                   key={`${dateStr}-${index}`}
//                   type="button"
//                   disabled={isPast}
//                   onClick={(e) => {
//                     e.preventDefault();
//                     if (!isPast) handleDateClick(date);
//                   }}
//                   className={`
//           aspect-square rounded-lg text-sm font-bold transition-all duration-200
//           flex items-center justify-center
//           ${
//             isPast
//               ? "text-gray-400 bg-gray-50 cursor-not-allowed" // Darker gray + light background for past dates
//               : "text-gray-900 hover:bg-blue-100 cursor-pointer active:scale-95" // Deep black for future dates
//           }
//           ${isToday ? "ring-2 ring-blue-500 text-blue-600" : ""}
//           ${
//             isStart || isEnd
//               ? "!bg-blue-600 !text-white hover:!bg-blue-700 shadow-md"
//               : isInRange
//                 ? "bg-blue-100 !text-blue-900"
//                 : ""
//           }
//         `}
//                 >
//                   {date.getDate()}
//                 </button>
//               );
//             })}
//           </div>

//           {/* Footer Actions */}
//           <div className="mt-8 flex justify-end items-center gap-3 border-t pt-6">
//             <div className="mr-auto text-sm text-gray-500">
//               {startDate && (
//                 <span>
//                   Range: <strong>{startDate}</strong>{" "}
//                   {endDate ? `to ${endDate}` : "(Select end date)"}
//                 </span>
//               )}
//             </div>
//             <button
//               onClick={onClose}
//               className="px-5 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={onApply}
//               className="px-6 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 font-bold shadow-lg shadow-blue-200 transition-all active:transform active:scale-95"
//             >
//               Apply Range
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// /* ---------------- Helper Functions ---------------- */
// function formatDate(date) {
//   if (!date) return "N/A";
//   try {
//     return new Date(date).toLocaleString("en-US", {
//       month: "short",
//       day: "numeric",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   } catch {
//     return "Invalid Date";
//   }
// }



import { useState, useMemo, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import Loader from "../components/Loader";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import Pagination from "@mui/material/Pagination";
import {
  FiCalendar,
  FiClock,
  FiZap,
  FiChevronDown,
  FiFilter,
  FiTrendingUp,
  FiCpu,
  FiLayers,
  FiShield,
  FiTarget,
  FiActivity,
  FiWind, FiRepeat, FiPlay, FiPower, FiThermometer,
  FiSlash,
  FiSun
} from "react-icons/fi";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { describeSubscription, TONE_CLASSES } from "../utils/subscription";



// --- STATS CARD ---
function StatCard({ icon: Icon, label, value, colorClass }) {
  return (
    <div className="bg-white/80 backdrop-blur-md p-4 rounded-3xl shadow-sm border border-white flex items-center gap-4 flex-1 min-w-[200px] transition-transform hover:scale-[1.02]">
      <div className={`p-3 rounded-2xl ${colorClass}`}>
        <Icon size={20} />
      </div>
      <div>
        <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">
          {label}
        </p>
        <p className="text-xl font-black text-slate-800">
          {(value || 0).toLocaleString()}
        </p>
      </div>
    </div>
  );
}

// --- DETAILED DEVICE CARD ---
function DeviceCard({i, device ,fetchScheduleDetails, setHoveredSchedule}) {
  console.log("dewge",device)
  const displayName =
    device.alias && device.alias !== "actions.alias"
      ? device.alias
      : device.meta?.alias || `ID: ${device.deviceId.slice(-6)}`;

  // Logic for States
  const isExpectedOn = device.deviceOn;
  const isPhysicallyOnline =
    device.status === "online" || device.meta?.status === "online";

  // Logic for Features (Highlighting only if supported)
  const showBrightness =
    device.brightnessSupported || device.meta?.brightnessSupported;
  const smartRestore = device.smartRestore?.enabled;
  let mode = device.mode || "Auto"; 
  let heatsetpoint = device.heatSetpoint;
  let coolsetpoint = device.coolSetpoint;
  let fanmode = device.fanMode;
  

  // Render Tapo Card
// Render Tapo Card
  const renderTapo = () => {
    // 1. Strict Capability Check: Only show brightness if hardware supports it
    const hasBrightnessSupport = showBrightness;
    const brightnessValue = device.brightnessLevel || 0;

    // 2. Dynamic Icon Logic based on hardware type
    const renderIntentIcon = () => {
      if (!isExpectedOn) return <FiSlash className="text-slate-500 opacity-40" size={24} />;
      
      // If it's a dimmer, use the glowing sun symbol to fill the circular container
      if (hasBrightnessSupport) {
        return (
          <FiSun 
            size={28} 
            className="text-white animate-pulse" 
            style={{ filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.9))' }}
          />
        );
      }
      // Standard Power Switch
      return <FiZap className="text-white animate-pulse" size={24} />;
    };

    return (
      <div
        className={`group relative p-5 rounded-[3.5rem] border-2 transition-all duration-700 bg-white ${
          isExpectedOn
            ? hasBrightnessSupport 
              ? "border-amber-400 shadow-[0_25px_60px_-15px_rgba(251,191,36,0.3)] scale-[1.02]"
              : "border-blue-400 shadow-[0_25px_60px_-15px_rgba(59,130,246,0.3)] scale-[1.02]"
            : "border-slate-100 opacity-95 shadow-sm"
        }`}
      >
        {/* Top connectivity bar */}
        <div className="flex items-center justify-between mb-8 px-2">
          <span className="text-[10px] font-black text-red-500 bg-red-50 px-3 py-1 rounded-full uppercase tracking-widest">
            Tapo
          </span>
          <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${isPhysicallyOnline ? "bg-emerald-50 text-emerald-600" : "bg-rose-50 text-rose-600"}`}>
             <div className={`w-1.5 h-1.5 rounded-full ${isPhysicallyOnline ? "bg-emerald-500 animate-pulse" : "bg-rose-500"}`} />
             <span className="text-[10px] font-black uppercase tracking-tighter">
               {isPhysicallyOnline ? "Live" : "Offline"}
             </span>
          </div>
        </div>

        {/* Hero Section: Icon & Intent */}
        <div className="flex items-center gap-5 mb-8 px-2">
          <div
            className={`relative w-16 h-16 rounded-full flex items-center justify-center transition-all duration-700 shadow-xl ${
              isExpectedOn
                ? hasBrightnessSupport 
                  ? "bg-gradient-to-br from-yellow-400 to-orange-500" 
                  : "bg-gradient-to-br from-blue-500 to-indigo-600"
                : "bg-slate-800"
            }`}
          >
            {isExpectedOn && (
              <div className={`absolute inset-0 rounded-full blur-2xl opacity-40 animate-pulse ${
                hasBrightnessSupport ? "bg-orange-400" : "bg-blue-400"
              }`} />
            )}
            <div className="relative z-10">{renderIntentIcon()}</div>
          </div>

          <div>
            <p className={`text-[9px] font-black uppercase tracking-[0.2em] mb-1 ${isExpectedOn ? "text-amber-600" : "text-slate-400"}`}>
              Schedule Intent
            </p>
            <p className={`text-2xl font-black leading-none tracking-tighter ${isExpectedOn ? "text-slate-900" : "text-slate-400"}`}>
              {isExpectedOn ? "POWER ON" : "POWER OFF"}
            </p>
          </div>
        </div>

        {/* Device Label: Rounded Pebble style */}
        <div className={`p-5 rounded-[2.5rem] transition-colors mb-6 ${isExpectedOn ? "bg-slate-50/80" : "bg-slate-50"}`}>
          <p className="text-sm font-black text-slate-800 truncate px-1">
            {displayName}
          </p>
          <p className="text-[8px] font-mono font-bold text-slate-300 mt-1 uppercase tracking-widest px-1">
            ID: {device.deviceId.slice(-12)}
          </p>
        </div>

        {/* 3. Conditional Dimmer: Only displays if hardware supports it */}
        {hasBrightnessSupport && isExpectedOn && (
          <div className="space-y-3 px-3 mb-8">
            <div className="flex justify-between items-end">
              <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest italic opacity-60">
                Intensity Level
              </span>
              <span className="text-xl font-black text-orange-600 leading-none">
                {brightnessValue}%
              </span>
            </div>
            <div className="h-3 bg-slate-100 rounded-full p-0.5 overflow-hidden shadow-inner border border-slate-200/50">
              <div
                className="h-full rounded-full transition-all duration-1000 bg-gradient-to-r from-orange-500 to-amber-300 shadow-[0_0_8px_rgba(251,146,60,0.4)]"
                style={{ width: `${brightnessValue}%` }}
              />
            </div>
          </div>
        )}

        {/* Smart Restore Logic: Closes the empty space at bottom */}
        {device.smartRestore?.enabled && (
          <div className="p-5 rounded-[2.5rem] bg-indigo-50 border border-indigo-100 relative overflow-hidden">
            <div className="flex items-center gap-2 mb-3">
              <FiShield className="text-indigo-500" size={12} />
              <p className="text-[9px] font-black uppercase text-indigo-500 tracking-[0.15em]">
                Smart Guard
              </p>
            </div>
            <div className="flex justify-between items-center">
              <div className="flex flex-col">
                <span className="text-slate-400 text-[7px] uppercase font-black mb-1">State Target</span>
                <span className="text-xs font-black text-indigo-800 uppercase">
                  {device.smartRestore?.expectedState ? "Restore On" : "Restore Off"}
                </span>
              </div>
              {hasBrightnessSupport && device.smartRestore?.expectedBrightness !== null && (
                <div className="flex flex-col text-right">
                  <span className="text-slate-400 text-[7px] uppercase font-black mb-1">Dim Target</span>
                  <span className="text-xs font-black text-indigo-800">{device.smartRestore.expectedBrightness}%</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };
  // Render Tapo Card
  // const renderTapo = () => (
  //   <div
  //     className={`group relative p-5 rounded-[2.5rem] border-2 transition-all duration-500 ${
  //       isExpectedOn
  //         ? "bg-white border-amber-400 shadow-[0_20px_50px_-12px_rgba(251,191,36,0.3)] scale-[1.02]"
  //         : "bg-slate-50 border-slate-200 opacity-90"
  //     }`}
  //   >
  //     {/* Top Bar: Connectivity */}
   

  //         <div className="flex items-center justify-between mb-8">
  //         <span className="text-[10px] font-black text-red-500 bg-red-50 px-3 py-1 rounded-full uppercase tracking-widest">
  //           Tapo
  //         </span>
  //            {device.smartRestore?.enabled && (
  //           <div
  //             className="mt-4 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-[10px] font-black uppercase tracking-widest border border-indigo-100 cursor-pointer"
  //             // onMouseEnter={(e) =>
  //             //   fetchScheduleDetails(device.smartRestore.sourceScheduleId, e)
  //             // }
  //             // onMouseLeave={() => setHoveredSchedule(null)}
  //           >
  //             <FiShield size={12} />
  //           </div>
  //         )}
  //         <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${isPhysicallyOnline ? "bg-emerald-50 text-emerald-600" : "bg-rose-50 text-rose-600"}`}>
  //            <div className={`w-2 h-2 rounded-full ${isPhysicallyOnline ? "bg-emerald-500 animate-pulse" : "bg-rose-500"}`} />
  //            <span className="text-[10px] font-black uppercase tracking-tighter">
  //              {isPhysicallyOnline ? "Live" : "Offline"}
  //            </span>
  //         </div>
  //       </div>

  //     {/* Main Intent Section */}
  //     <div className="flex items-center gap-4 mb-6">
  //       <div
  //         className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-all duration-500 shadow-lg ${
  //           isExpectedOn
  //             ? "bg-gradient-to-br from-amber-400 to-orange-500 text-white"
  //             : "bg-slate-800 text-slate-500"
  //         }`}
  //       >
  //         <FiZap size={24} className={isExpectedOn ? "animate-pulse" : ""} />
  //       </div>
  //       <div>
  //         <p
  //           className={`text-[10px] font-black uppercase tracking-widest ${isExpectedOn ? "text-amber-600" : "text-slate-400"}`}
  //         >
  //           Schedule Intent
  //         </p>
  //         <p
  //           className={`text-xl font-black leading-none mt-1 ${isExpectedOn ? "text-slate-900" : "text-slate-500"}`}
  //         >
  //           {isExpectedOn ? "POWER ON" : "POWER OFF"}
  //         </p>
  //       </div>
  //     </div>

  //     {/* Device Info */}
  //     <div
  //       className={`p-4 rounded-3xl ${isExpectedOn ? "bg-amber-50/50" : "bg-white border border-slate-100"} mb-4`}
  //     >
  //       <p className="text-sm font-black text-slate-800 truncate">
  //         {displayName}
  //       </p>
  //       <p className="text-[9px] font-mono font-bold text-slate-400 mt-1 uppercase">
  //         ID: {device.deviceId.slice(-12)}
  //       </p>
  //     </div>

  //     {/* Dynamic Feature: Brightness */}
  //     {showBrightness && isExpectedOn && (
  //       <div className="space-y-2 mt-4">
  //         <div className="flex justify-between items-end px-1">
  //           <span className="text-[10px] font-black text-slate-400 uppercase italic">
  //             Dimmer Level
  //           </span>
  //           <span
  //             className={`text-lg font-black ${isExpectedOn ? "text-orange-600" : "text-slate-300"}`}
  //           >
  //             {device.brightnessLevel || 0}%
  //           </span>
  //         </div>
  //         <div className="h-3 bg-slate-200 rounded-full p-0.5 overflow-hidden shadow-inner">
  //           <div
  //             className={`h-full rounded-full transition-all duration-1000 ${
  //               isExpectedOn
  //                 ? "bg-gradient-to-r from-orange-500 to-amber-300"
  //                 : "bg-slate-300"
  //             }`}
  //             style={{
  //               width: `${isExpectedOn ? device.brightnessLevel || 5 : 0}%`,
  //             }}
  //           />
  //         </div>
  //       </div>
  //     )}

  //     {smartRestore && (
  //       <div className="mt-4 p-3 rounded-2xl bg-indigo-50 border border-indigo-100">
  //         <p className="text-[9px] font-black uppercase text-indigo-500 mb-1">
  //           Smart Restore
  //         </p>

  //         <div className="text-[10px] font-bold text-slate-600 space-y-1">
  //           <p>
  //             Expected:{" "}
  //             <span className="text-indigo-700">
  //               {device.smartRestore?.expectedState ? "ON" : "OFF"}
  //             </span>
  //           </p>

  //           {device.smartRestore?.expectedBrightness !== null && (
  //             <p>
  //               Brightness:{" "}
  //               <span className="text-indigo-700">
  //                 {device.smartRestore.expectedBrightness}%
  //               </span>
  //             </p>
  //           )}
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // );
// Render Honeywell Card
const renderHoneywell = () => {
    // --- 1. DATA MAPPING & CONVERSION ---
    const intentMode = device.mode || "Auto";
    const intentFan = device.fanMode || "Auto";
    const fHeat = device.heatSetpoint;
    const fCool = device.coolSetpoint;

    // Helper to convert and format
    const formatTemp = (f) => {
      if (!f) return { c: "--", f: "--" };
      const c = Math.round((f - 32) * 5 / 9);
      return { c, f };
    };

    const heat = formatTemp(fHeat);
    const cool = formatTemp(fCool);

    // Hardware Reality
    const meta = device.meta || {};
    const hardwareMode = device.mode || "Off";
    const allowedModes = meta.allowedModes || [];

    const getFanIcon = (mode) => {
      switch (mode?.toLowerCase()) {
        case "on": return <FiPlay size={14} className="text-emerald-400" />;
        case "circulate": return <FiRepeat size={14} className="text-blue-400" />;
        default: return <FiWind size={14} className="text-slate-400" />;
      }
    };

    return (
      <div className="group relative p-5 rounded-[3.5rem] border border-slate-100 transition-all duration-700 bg-white shadow-[0_15px_50px_-20px_rgba(0,0,0,0.06)] hover:scale-[1.01]">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-5 px-2">
          <span className="text-[9px] font-black text-red-500 bg-red-50 px-3 py-1 rounded-full uppercase tracking-widest">
            Honeywell
          </span>
          <div className={`flex items-center gap-1.5 px-3 py-1 rounded-full border ${isPhysicallyOnline ? "bg-emerald-50 border-emerald-100 text-emerald-600" : "bg-rose-50 border-rose-100 text-rose-600"}`}>
             <div className={`w-1.5 h-1.5 rounded-full ${isPhysicallyOnline ? "bg-emerald-500 animate-pulse" : "bg-rose-500"}`} />
             <span className="text-[8px] font-black uppercase tracking-tighter">
               {isPhysicallyOnline ? "Live" : "Offline"}
             </span>
          </div>
        </div>

        {/* Device Info */}
        <div className="mb-6 text-center">
          <h3 className="text-lg font-black text-slate-800 leading-tight tracking-tight">{displayName}</h3>
          <p className="text-[9px] font-bold text-slate-300 uppercase tracking-[0.3em] mt-1 italic">Thermostat Intent</p>
        </div>

        {/* DUAL TEMP INTENT SECTION */}
        <div className={`p-6 rounded-[3rem] transition-all duration-500 ${
          intentMode === 'Heat' ? "bg-orange-50/60" :
          intentMode === 'Cool' ? "bg-blue-50/60" :
          intentMode === 'Auto' ? "bg-indigo-50/50 shadow-inner" : 
          "bg-slate-50"
        }`}>
          <p className="text-[8px] font-black uppercase tracking-[0.2em] mb-4 text-center opacity-40">Target Setpoints</p>

          <div className="flex items-center justify-center">
            {intentMode === 'Auto' ? (
              <div className="flex items-center justify-around w-full">
                {/* Cool Column */}
                <div className="text-center">
                  <span className="block text-[7px] font-black text-blue-400 uppercase mb-1">Cool</span>
                  <div className="flex items-baseline justify-center gap-1">
                    <span className="text-3xl font-black text-blue-900 leading-none">{cool.c}°</span>
                    <span className="text-xs font-bold text-blue-400 opacity-60">{cool.f}F</span>
                  </div>
                </div>
                
                <div className="h-8 w-[1px] bg-indigo-100 mx-2" />

                {/* Heat Column */}
                <div className="text-center">
                  <span className="block text-[7px] font-black text-orange-400 uppercase mb-1">Heat</span>
                  <div className="flex items-baseline justify-center gap-1">
                    <span className="text-3xl font-black text-orange-900 leading-none">{heat.c}°</span>
                    <span className="text-xs font-bold text-orange-400 opacity-60">{heat.f}F</span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <span className={`block text-[8px] font-black uppercase mb-1 ${intentMode === 'Heat' ? 'text-orange-400' : 'text-blue-400'}`}>
                  {intentMode} Target
                </span>
                <div className="flex items-baseline justify-center gap-2">
                  <span className={`text-5xl font-black tracking-tighter leading-none ${intentMode === 'Heat' ? 'text-orange-900' : 'text-blue-900'}`}>
                    {intentMode === 'Heat' ? heat.c : cool.c}°
                  </span>
                  <span className={`text-lg font-bold opacity-40 ${intentMode === 'Heat' ? 'text-orange-600' : 'text-blue-600'}`}>
                    {intentMode === 'Heat' ? heat.f : cool.f}F
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Fan Status Capsule */}
        <div className="mt-6 flex items-center justify-between px-5 py-3 bg-slate-900 rounded-full text-white shadow-xl shadow-slate-200/50">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/10 rounded-full">{getFanIcon(intentFan)}</div>
            <div>
              <p className="text-[7px] font-black text-slate-500 uppercase leading-none mb-1">Fan</p>
              <p className="text-[10px] font-bold uppercase">{intentFan}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-[7px] font-black text-slate-500 uppercase leading-none mb-1">System</p>
            <p className="text-[10px] font-bold text-slate-300 uppercase">{hardwareMode}</p>
          </div>
        </div>

        {/* Mode Pills */}
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          {allowedModes.map(m => (
            <span key={m} className={`px-4 py-1.5 rounded-full text-[8px] font-black uppercase border transition-all ${
              m.toLowerCase() === intentMode.toLowerCase()
              ? "bg-slate-900 text-white border-slate-900 shadow-lg scale-105" 
              : "bg-white text-slate-300 border-slate-100"
            }`}>
              {m}
            </span>
          ))}
        </div>
      </div>
    );
  };

  // Brand Router
  const brand = (device.brand || "tapo").toLowerCase();

  switch (brand) {
    case "tapo":
      return renderTapo();
    case "honeywell":
      return renderHoneywell();
    default:
      return renderTapo(); // Default fallback
  }
}



export default function DashboardDetailed() {
  const token = useSelector((state) => state.user.token);
  const today = new Date().toISOString().split("T")[0];

  const [data, setData] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() + 394);
    return d.toISOString().split("T")[0];
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 25,
    total: 0,
    totalPages: 1,
  });
  const [showSchedules, setShowSchedules] = useState(() => {
    const saved = localStorage.getItem("showSchedules");
    return saved ? JSON.parse(saved) : false;
  });
  const [hoveredUser, setHoveredUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [userLoading, setUserLoading] = useState(false);
  const [hoveredSchedule, setHoveredSchedule] = useState(null);
  const [hoverLoading, setHoverLoading] = useState(false);
  const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
  const [popupPos, setPopupPos] = useState({ x: 0, y: 0 });
  const handleDateChange = (newStart, newEnd) => {
    const start = new Date(newStart);
    const end = new Date(newEnd);
    const maxRange = 730;

    if (start < new Date(today)) newStart = today;
    if (end < new Date(newStart)) newEnd = newStart;

    const diffDays = Math.ceil(Math.abs(end - start) / (1000 * 60 * 60 * 24));
    if (diffDays > maxRange) {
      const adjustedEnd = new Date(newStart);
      adjustedEnd.setDate(adjustedEnd.getDate() + maxRange);
      newEnd = adjustedEnd.toISOString().split("T")[0];
    }

    setStartDate(newStart);
    setEndDate(newEnd);
  };
  useEffect(() => {
    localStorage.setItem("showSchedules", JSON.stringify(showSchedules));
  }, [showSchedules]);
  const fetchScheduleData = async (pageNumber = 1) => {
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/fetchupcomingschedules`,
        {
          startDate,
          endDate,
          page: pageNumber,
          limit: pagination.limit,
          showSchedules,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      console.log("res",response.data.data)
      if (response.data?.success) {
        setData(response.data.data);
        setStats(response.data.stats);
        setPagination({
          page: response.data.page,
          limit: response.data.limit,
          total: response.data.total,
          totalPages: response.data.totalPages,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

   const formatDisplay = (iso, showHebrew = false) => {
    
      if (!iso) return "";
      const date = new Date(iso);
      const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      // const gregorian = dayjs(date).tz
      //   ? dayjs(date).tz(userTz).format("MMM DD, YYYY • hh:mm A")
      //   : dayjs(date).format("MMM DD, YYYY • hh:mm A");
      if (!showHebrew) return "";
      const hebrewDate = new Intl.DateTimeFormat("en-u-ca-hebrew", {
        day: "numeric",
        month: "long",
        year: "numeric",
        timeZone: userTz,
      }).format(date);
      // return `${gregorian} (${hebrewDate})`;
       return `[${hebrewDate}]`;
    };
  const fetchUserDetails = async (userId) => {
    if (!userId) return;

    try {
      setUserLoading(true);

      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/user-stats`,
        { userId },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setUserDetails(res.data?.data || null);
    } catch (err) {
      console.error("User fetch error", err);
    } finally {
      setUserLoading(false);
    }
  };
  const fetchScheduleDetails = async (scheduleId, event) => {
    if (!scheduleId) return;

    setHoverLoading(true);
    setHoveredSchedule(null);

    // Position for popup
    setHoverPosition({
      x: event.clientX + 10,
      y: event.clientY + 10,
    });

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/schedule/${scheduleId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (res.data?.data) {
        setHoveredSchedule(res.data.data);
      }
    } catch (err) {
      console.error("Hover fetch error", err);
    } finally {
      setHoverLoading(false);
    }
  };
  const handleUserHover = (userId,e) => {
    setHoveredUser(userId);
      setPopupPos({
    x: e.clientX,
    y: e.clientY,
  });
    fetchUserDetails(userId);
  };

  const handleUserLeave = () => {
    setHoveredUser(null);
    setUserDetails(null);
  };
  useEffect(() => {
    fetchScheduleData(1);
  }, [startDate, endDate, showSchedules]);

  const columns = useMemo(
    () => [
      {
        header: "Schedule",
        cell: ({ row }) => (
          <div className="flex items-center gap-4">
            <div className="relative">
              <div className="p-3 bg-gradient-to-br from-indigo-500 to-violet-600 rounded-2xl text-white shadow-lg">
                <FiCalendar size={20} />
              </div>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <p className="text-sm font-black text-slate-800 leading-none mb-1">
                 
                </p>
                {row.original.smartRestore && (
                  <span className="flex items-center gap-1.5 bg-gradient-to-r from-pink-500 to-indigo-500 text-white px-2.5 py-0.5 rounded-full text-xs font-semibold shadow-sm">
      
      <span className="text-sm leading-none">✨</span>
      
      SR
    </span>
                )} 
                {/* <span style={{ fontWeight: 500 }}   onMouseEnter={(e) => handleUserHover(row.original.userId, e)}
                      onMouseLeave={handleUserLeave}>
  {row.original.scheduleName}
</span>{" "} */}
<div
  className="relative inline-block"
  onMouseEnter={(e) => handleUserHover(row.original.userId, e)}
  onMouseLeave={handleUserLeave}
>
  <span>{row.original.scheduleName}</span>

  {hoveredUser === row.original.userId && (
    <div className="absolute left-full top-0 ml-3 w-[320px] z-50">
      {/* popup content */}
    </div>
  )}
</div>
<span style={{ color: "#666", fontSize: "13px" }}>
  {formatDisplay(
    row.original?.nextRunAt,
    row.original?.calenderType?.toLowerCase() === "hebrew"
  )}
</span>
              </div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                {row.original.calenderType} • {row.original.scheduleType}
              </p>
            </div>
          </div>
        ),
      },
      {
        header: "Status & Logic",
        cell: ({ row }) => (
          <div className="flex flex-col gap-1.5">
            <span
              className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-2xl text-[10px] font-black uppercase tracking-widest border-2 ${
                row.original.status === "active"
                  ? "bg-emerald-50 text-emerald-600 border-emerald-100/50"
                  : "bg-slate-50 text-slate-400 border-slate-100"
              }`}
            >
              <div
                className={`w-1.5 h-1.5 rounded-full ${row.original.status === "active" ? "bg-emerald-500 animate-pulse" : "bg-slate-300"}`}
              />
              {row.original.status}
            </span>
            <div className="flex items-center gap-1.5 px-2 text-[9px] font-black text-indigo-500 uppercase">
              <FiTarget size={10} /> Rounding: {row.original.roundToClosest}
            </div>
          </div>
        ),
      },
      {

        
        header: "Execution",
        cell: ({ row }) => {
          const date = new Date(row.original.nextRunAt);
          return (
            <div className="bg-slate-50/50 px-4 py-2 rounded-2xl border border-slate-100 inline-block">
              <div className="flex items-center gap-2 text-indigo-600 mb-0.5">
                <FiClock size={14} />
                <span className="text-sm font-black uppercase tracking-tight">
                  {date.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center">
                {date.toLocaleDateString([], {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </p>
            </div>
          );
        },
      },
      {
        header: "Setup",
        cell: ({ row }) => (
          <div className="flex flex-col">
            <span className="text-sm font-black text-slate-800">
              {row.original.devices} Devices
            </span>
            <span className="text-[9px] font-bold text-slate-400 uppercase tracking-tighter">
              Command Stack
            </span>
          </div>
        ),
      },
      {
        header: "Action",
        cell: ({ row }) => (
          <button
            onClick={() =>
              setExpanded((prev) => ({ ...prev, [row.id]: !prev[row.id] }))
              
            }
            className={`p-3 rounded-2xl transition-all duration-300 ${expanded[row.id] ? "bg-indigo-600 text-white rotate-180" : "bg-indigo-50 text-indigo-600 hover:bg-indigo-100"}`}
          >
            <FiChevronDown size={20} />
          </button>
        ),
      },
    ],
    [expanded],
  );

  const table = useReactTable({
    data,
    columns,
    getRowId: (row) => `${row.scheduleId}-${row.nextRunAt}`,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="min-h-screen bg-[#FDFDFF] p-6 md:p-12 text-slate-800 font-sans">
      <div className="max-w-7xl mx-auto space-y-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <span className="bg-indigo-600 text-white text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest shadow-lg shadow-indigo-100">
                Future Projection
              </span>
            </div>
            <h1 className="text-5xl font-black tracking-tighter text-slate-900">
              Upcoming{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-500">
                Schedules
              </span>
            </h1>
          </div>

          <div className="flex items-center gap-2 bg-white p-2 rounded-3xl border border-slate-200 shadow-sm">
            <FiFilter className="text-slate-400 ml-4" />
            <input
              type="date"
              min={today}
              value={startDate}
              onChange={(e) => handleDateChange(e.target.value, endDate)}
              className="bg-transparent border-none text-xs font-black text-slate-700 focus:ring-0"
            />
            <div className="h-4 w-[1px] bg-slate-200 mx-2" />
            <input
              type="date"
              min={startDate}
              value={endDate}
              onChange={(e) => handleDateChange(startDate, e.target.value)}
              className="bg-transparent border-none text-xs font-black text-slate-700 focus:ring-0 mr-4"
            />
          </div>
        </div>
        <div className="flex items-center gap-3 ml-4">
          <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
            Mode
          </span>

          {/* <button
            onClick={() => setShowSchedules((prev) => !prev)}
            className={`px-4 py-2 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all ${
              showSchedules
                ? "bg-indigo-600 text-white shadow-lg"
                : "bg-indigo-600 text-white shadow-lg"
            }`}
          >
            {!showSchedules ? "Schedules (Unique)" : "All Runs"}
          </button> */}
          <div className="inline-flex bg-gray-100 rounded-2xl p-1 border border-gray-200 shadow-sm">
  
  <button
    onClick={() => setShowSchedules(true)}
    className={`px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${
      showSchedules
        ? "bg-white text-slate-800 shadow"
        : "text-slate-400"
    }`}
  >
    Schedules
  </button>

  <button
    onClick={() => setShowSchedules(false)}
    className={`px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${
      !showSchedules
        ? "bg-white text-slate-800 shadow"
        : "text-slate-400"
    }`}
  >
    All Runs
  </button>

</div>
        </div>

        {stats && (
          <div className="flex flex-wrap gap-6">
            {/* Total Schedules in Database */}
            <StatCard
              icon={FiLayers}
              label="Total Schedules"
              value={stats.totalSchedules}
              colorClass="bg-slate-100 text-slate-600"
            />

            {/* Currently Running/Active Schedules */}
            <StatCard
              icon={FiActivity}
              label="Active Schedules"
              value={stats.activeSchedules}
              colorClass="bg-indigo-50 text-indigo-600"
            />

            {/* Sum of all Actions (The 153 count) */}
            <StatCard
              icon={FiCpu}
              label="Total Devices Affected"
              value={stats.totalDevices}
              colorClass="bg-amber-50 text-amber-600"
            />

            {/* Upcoming Cron Instances (Filtered Range) */}
            <StatCard
              icon={FiTrendingUp}
              label="Total Upcoming Runs"
              value={stats.upcomingCronJobs}
              colorClass="bg-emerald-50 text-emerald-600"
            />
          </div>
        )}

        {/* Table */}
        <div className="bg-white rounded-[40px] shadow-xl border border-white overflow-hidden relative">
          {loading && (
            <div className="absolute inset-0 bg-white/80 z-10 flex flex-col items-center justify-center gap-4">
              <Loader />
            </div>
          )}

          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                {table.getHeaderGroups().map((hg) => (
                  <tr key={hg.id} className="border-b border-slate-50">
                    {hg.headers.map((h) => (
                      <th
                        key={h.id}
                        className="px-8 py-6 text-[10px] font-black text-slate-400 uppercase tracking-widest"
                      >
                        {flexRender(h.column.columnDef.header, h.getContext())}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody className="divide-y divide-slate-50">
                {table.getRowModel().rows.map((row) => (
                  <Fragment key={row.id}>
                    <tr
                      // onMouseEnter={() => handleUserHover(row.original.userId)}
                      // onMouseLeave={handleUserLeave}
                      className={`transition-all duration-300 ${expanded[row.id] ? "bg-indigo-50/30" : "hover:bg-slate-50"}`}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-8 py-6">
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext(),
                          )}
                        </td>
                      ))}
                    </tr>

                    {expanded[row.id] && (
                    
                      <tr>
                        <td
                          colSpan={columns.length}
                          className="px-12 py-10 bg-gradient-to-b from-indigo-50/40 to-white"
                        >
                          <div className="space-y-6">
                            <h3 className="text-xs font-black text-slate-800 uppercase tracking-widest">
                              Device Stack
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                              {row.original.actions.map((action, idx) => (
                                <DeviceCard key={idx} device={action} fetchScheduleDetails={fetchScheduleDetails} setHoveredSchedule={setHoveredSchedule} />
                              ))}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
       

        {/* Pagination */}
        <div className="flex flex-col items-center gap-6 py-10">
          <Pagination
            count={pagination.totalPages}
            page={pagination.page}
            onChange={(_, val) => fetchScheduleData(val)}
            color="primary"
            shape="rounded"
          />
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
            {pagination.total} Upcoming Runs Projected
          </p>
        </div>
      </div>

      {(hoverLoading || hoveredSchedule) && (
  <div
    style={{
      position: "fixed",
      top: hoverPosition.y,
      left: hoverPosition.x,
      zIndex: 9999,
    }}
    className="w-[320px] bg-white rounded-2xl shadow-2xl border border-slate-200 p-4"
  >
    {hoverLoading ? (
      <p className="text-xs font-bold text-slate-400">Loading...</p>
    ) : (
      <>
        {/* Schedule Name */}
        <p className="text-sm font-black text-slate-800">
         Overwrite by : {hoveredSchedule.name} schedule
        </p>

        {/* User */}
        <div className="flex items-center gap-3 mt-3">
          <img
            src={hoveredSchedule.userId?.avatar}
            alt=""
            className="w-8 h-8 rounded-full"
          />
          <div>
            <p className="text-xs font-bold text-slate-700">
              {hoveredSchedule.userId?.name}
            </p>
            <p className="text-[10px] text-slate-400">
              {hoveredSchedule.userId?.email}
            </p>
          </div>
        </div>

        {/* Timing */}
        <div className="mt-3 text-[10px] text-slate-500 font-bold uppercase">
          {hoveredSchedule.when?.calenderType} • {hoveredSchedule.when?.scheduleType}
        </div>

        {/* Next Run */}
        <div className="mt-2 text-xs font-black text-indigo-600">
          Next Run:{" "}
          {new Date(hoveredSchedule.when?.nextRunAt).toLocaleString()}
        </div>

        {/* Actions Count */}
        <div className="mt-2 text-[10px] text-slate-400">
          {hoveredSchedule.actions?.length} Devices
        </div>
      </>
    )}
  </div>
)}
{hoveredUser && (
  <div
    className="fixed z-50 w-[320px]"
    style={{
      top: popupPos.y + 10,
      left: popupPos.x + 10,
    }}
  >
            <div className="bg-white rounded-3xl shadow-2xl border border-slate-200 p-5 transition-all">
              {userLoading ? (
                <p className="text-xs font-bold text-slate-400">Loading...</p>
              ) : userDetails ? (
                <>
                  {/* Profile */}
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={userDetails.profile?.info?.avatar}
                      className="w-12 h-12 rounded-full border"
                    />
                    <div>
                      <p className="text-sm font-black text-slate-800">
                        {userDetails.profile?.info?.name}
                      </p>
                      <p className="text-[10px] text-slate-400">
                        {userDetails.profile?.info?.email}
                      </p>
                    </div>
                  </div>

                  {/* Subscription — status says WHY, hasAccess says WHETHER.
                      "Cancelling" and "Billing issue" both still have access. */}
                  <div className="mb-3">
                    <p className="text-[10px] font-black uppercase text-slate-400">
                      Plan
                    </p>
                    {(() => {
                      const sub = describeSubscription(userDetails.subscription);
                      return (
                        <div className="flex flex-wrap items-center gap-1.5">
                          <span
                            title={sub.hint}
                            className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${TONE_CLASSES[sub.tone]}`}
                          >
                            {sub.label}
                          </span>
                          <span
                            className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${
                              sub.hasAccess
                                ? TONE_CLASSES.success
                                : TONE_CLASSES.danger
                            }`}
                          >
                            {sub.hasAccess ? "Has access" : "No access"}
                          </span>
                        </div>
                      );
                    })()}
                  </div>

                  {/* Devices */}
                  <div className="mb-3">
                    <p className="text-[10px] font-black uppercase text-slate-400">
                      Devices
                    </p>
                    <p className="text-sm font-bold">
                      {userDetails.infrastructure?.devices?.total} total •{" "}
                      <span className="text-emerald-600">
                        {userDetails.infrastructure?.devices?.online} online
                      </span>
                    </p>
                  </div>

                  {/* Location */}
                  <div>
                    <p className="text-[10px] font-black uppercase text-slate-400">
                      Location
                    </p>
                    <p className="text-sm font-bold text-slate-700">
                      {userDetails.profile?.location?.city},{" "}
                      {userDetails.profile?.location?.state}
                    </p>
                  </div>
                </>
              ) : (
                <p className="text-xs text-slate-400">No data</p>
              )}
            </div>
          </div>
        )}

    </div>
  );
}
